import React from 'react';
import './PracticeMoment.css';

export default function PracticeMoment() {
  return (
    <section className="practice landing__section" aria-labelledby="practice-heading">
      <div className="landing__column">
        <div className="fade-up">
          <h2 className="practice__heading" id="practice-heading">
            A small moment of practice,<br />every day.
          </h2>
          <p className="practice__lede">
            The app asks quiet questions at the right moments. It remembers
            what you said. It doesn't tell anyone else.
          </p>

          <div className="practice__layout">
            <div className="practice__card">
              <div className="practice__card-header">Morning check-in · 08:07</div>

              <div className="practice__yesterday">
                <div className="practice__yesterday-label">Yesterday</div>
                <p className="practice__yesterday-answer">
                  I'm going to finish the backend endpoints and push them live.
                </p>
              </div>

              <div className="practice__card-divider" aria-hidden="true" />

              <p className="practice__card-prompt">
                Good morning. Before you open email:<br />
                What are you choosing to make<br />
                progress on today?
              </p>
              <div className="practice__card-input" aria-label="Answer field (example)">
                <span className="practice__card-cursor" aria-hidden="true" />
              </div>

              <div className="practice__card-divider" aria-hidden="true" />
              <p className="practice__card-note">Your answer stays on this device.</p>
            </div>

            <p className="practice__card-caption">
              Each morning, one question drawn from your goals — not a generic
              prompt. You see what you said yesterday. Your answer never leaves
              your device.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
